import PageMain from '../../components/Navigation/PageMain/PageMain';
import AiPromptManagement from '../../components/Settings/Ai/Prompts/AiPromptManagement';

export default function AiPromptManagementPage() {
    return (
        <PageMain pageTitle="AI Prompt Management" showError={false} showLoading={false}>
            <div className="settingsPage">
                <div className="settingsPage__wrapper">
                    <AiPromptManagement />
                </div>
            </div>
        </PageMain>
    );
}
